// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IaVTYlNWeWQWeyIv8PA9{flex-direction:column;gap:8px;display:flex}.rtNNxrO4dcycAVIHeNAF{grid-auto-flow:column;justify-content:flex-start;gap:8px;padding-bottom:14px;display:grid;overflow-x:auto}.wFhdWU7IwnUTNwnIIwDH{background:var(--background-neutral-subtle);word-break:break-all;border-radius:6px;padding:16px;overflow-y:auto}.wFhdWU7IwnUTNwnIIwDH a{color:var(--content-brand-secondary);font-family:Inter,sans-serif;font-size:14px;font-weight:400;line-height:20px;text-decoration:underline}.wFhdWU7IwnUTNwnIIwDH a:hover{color:var(--light-blue-90)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `IaVTYlNWeWQWeyIv8PA9`,
	"wrapAttachments": `rtNNxrO4dcycAVIHeNAF`,
	"message": `wFhdWU7IwnUTNwnIIwDH`
};
export default ___CSS_LOADER_EXPORT___;
